var _defs, _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgIconInbox = function SvgIconInbox(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b3bccf;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48,438H47v-2a2,2,0,0,0-2-2H35a2,2,0,0,0-2,2v2H32l-2,6v8a2,2,0,0,0,2,2H48a2,2,0,0,0,2-2v-8Zm-12-2h8a1,1,0,0,1,1,1v7H44a2,2,0,0,0-2,2v1a1,1,0,0,1-1,1H39a1,1,0,0,1-1-1v-1a2,2,0,0,0-2-2H35v-7A1,1,0,0,1,36,436Zm-3,5v3H32Zm14,11H33a1,1,0,0,1-1-1v-5h3a1,1,0,0,1,1,1v1a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2v-1a1,1,0,0,1,1-1h3v5A1,1,0,0,1,47,452Zm0-8v-3l1,3Z",
    transform: "translate(-30 -434)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInbox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_inbox.6e98fbfb.svg";
export { ForwardRef as ReactComponent };